/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFourByFour56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M21.12 32.43v-2.764h-2.54v-9.541h-3.936L7 29.87v2.56h8.075v3.445h3.504V32.43h2.542zm-5.943-7.274v4.51h-4.836c.389-.363.676-.703 1.188-1.36l2.562-3.331c.594-.748.881-1.201 1.086-1.677h.062c-.062.498-.062.884-.062 1.858z'
      />
      <path
        fill='currentColor'
        d='M21.368 35.875h3.771l2.029-2.674c.287-.408.533-.816.656-1.11h.04c.103.317.329.725.616 1.11l2.029 2.674h4.119l-4.53-5.915 4.181-5.416h-3.873l-1.762 2.425c-.246.362-.472.748-.595 1.11h-.04a4.196 4.196 0 00-.595-1.11l-1.763-2.425h-4.058l4.222 5.484-4.447 5.847z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M49 29.666v2.764h-2.541v3.445h-3.505V32.43H34.88v-2.56l7.645-9.745h3.935v9.54H49zm-5.943 0v-4.51c0-.974 0-1.36.061-1.858h-.061c-.205.476-.492.929-1.087 1.677l-2.561 3.33c-.513.658-.8.998-1.189 1.36h4.837z'
      />
      <path
        fill='currentColor'
        d='M48.25 43.5v-3.833h1.5V43.5A2.75 2.75 0 0147 46.25h-5.778v-1.5H47c.69 0 1.25-.56 1.25-1.25zM31.5 44.75h5.833v1.5H31.5v-1.5zM7.75 17.5v-5c0-.69.56-1.25 1.25-1.25h6.75v-1.5H9a2.75 2.75 0 00-2.75 2.75v5h1.5z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M5.75 4.5A4.75 4.75 0 001 9.25v37.5a4.75 4.75 0 004.75 4.75h44.5A4.75 4.75 0 0055 46.75V9.25a4.75 4.75 0 00-4.75-4.75H5.75zM2.5 9.25A3.25 3.25 0 015.75 6h44.5a3.25 3.25 0 013.25 3.25v37.5A3.25 3.25 0 0150.25 50H5.75a3.25 3.25 0 01-3.25-3.25V9.25z'
      />
    </svg>
  );
}

export default SvgFourByFour56;
